<template>
  <adn-modal ref="modalToShow" @after-hide="afterHide">
    <template #body>
      <strong>{{ i18n._('Pour voir les prix vous devez être connecté') }}</strong>
      <p
        v-if="i18n._('Créez un compte aladin afin de voir les prix de votre partenaire.') !== ' '"
        style="margin-top: 20px"
      >
        {{ i18n._('Créez un compte aladin afin de voir les prix de votre partenaire.') }}
      </p>
    </template>
    <template v-if="isFooterEnable" #footer>
      <adn-button markup="router-link" :route="{ name: 'login' }" kind="link">S'inscrire</adn-button>
      <adn-button markup="router-link" :route="{ name: 'login' }">Se connecter</adn-button>
    </template>
    <template></template>
  </adn-modal>
</template>

<script lang="ts">
import { defineComponent, watch, ref, toRefs } from 'vue'
import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'
import AdnModal, { type ModalToShow } from '@b2ag/design-system/src/components/AdnModal/AdnModal.vue'
import { i18n } from '@b2ag/locale'
import AdnButton from '@b2ag/design-system/src/components/AdnButton/AdnButton.vue'

export default defineComponent({
  name: 'PPricesModal',
  components: {
    AdnModal,
    AdnButton,
  },
  props: {
    showPricesModal: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const toShowPricesModal = toRefs(props).showPricesModal
    const modalToShow = ref<ModalToShow | null>(null)
    const afterHide = () => {
      emit('afterHide', false)
    }
    const isFooterEnable = !isWebViewFarmi()

    watch(
      () => toShowPricesModal.value,
      () => {
        if (toShowPricesModal.value) {
          modalToShow.value?.show()
        }
      },
    )

    return {
      modalToShow,
      afterHide,
      isFooterEnable,
      i18n,
    }
  },
})
</script>
